import { render, staticRenderFns } from "./BandejaDiagnosticadorComponente.vue?vue&type=template&id=7abab352"
import script from "./BandejaDiagnosticadorComponente.vue?vue&type=script&lang=js"
export * from "./BandejaDiagnosticadorComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports